import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';

const ResultItem = ({ item, user, onClick, onRemove }) => {
    const data = item || user;

    if (!data) return null;
    
    const getProfileSrc = (pic) => {
        if (!pic) return "/public/noAvatar.png";
        return pic.startsWith("http") ? pic : "/upload/" + pic;
    };

    const isKeyword = item.type === 'keyword';

    return (
        <div className="search-item" onClick={onClick}>
            {isKeyword ? (
                <div style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f0f2f5', borderRadius: '50%' }}>
                    <SearchIcon style={{ color: '#65676B' }} />
                </div>
            ) : (
                <img
                    className={onRemove ? "history-img" : ""}
                    src={getProfileSrc(item.profilePic)}
                    alt=""
                    style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }}
                />
            )}
            
            <div className="user-info" style={{ flex: 1, marginLeft: '10px' }}> 
                <span style={{ fontWeight: 500 }}>
                    {isKeyword ? item.text : item.name}
                </span>
            </div>

            {onRemove && (
                <CloseIcon
                    className="remove-item"
                    fontSize="small"
                    style={{ cursor: 'pointer', color: '#65676B' }}
                    onClick={(e) => {
                        e.stopPropagation(); 
                        onRemove(item.id);
                    }}
                />
            )}
        </div>
    );
};

export default ResultItem;